import { MuiBox, MuiGrid, MuiTypography } from "../../../../components";
import { CardForExternalLink } from "../../../../components/cardForExternalLink/CardForExternalLink";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { powerBIReportSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { useGridContainer } from "../../../../hooks/useGridContainer";
import { PowerBiReportValues } from "../../modelsAndSchemas/models";
import { useMediaQueries } from "../../../../hooks/useMediaQueries";

interface PowerBIReportsProps {
  reportList: PowerBiReportValues[];
}

export const PowerBIReports: React.FC<PowerBIReportsProps> = ({
  reportList,
}) => {
  const { fetchComponentTitle, fetchLabel, commonLabels } = useSiteCore();
  const { gridSizeMedium: gridSize } = useGridContainer();
  const headerLabel = fetchComponentTitle(powerBIReportSiteCoreKeys.header);
  const { isMobile } = useMediaQueries();

  const openInNewPageConfirmationLabel = fetchLabel(
    powerBIReportSiteCoreKeys.header,
    powerBIReportSiteCoreKeys.openInNewPageConfirmation,
  );
  const stayHere = fetchLabel(
    powerBIReportSiteCoreKeys.header,
    powerBIReportSiteCoreKeys.stayHere,
  );

  return (
    <MuiBox className="selectReportContainer">
      <MuiBox className="result-header">
        <MuiTypography variant="h2SemiBold" className="header-text">
          {headerLabel}
        </MuiTypography>
      </MuiBox>
      <MuiBox className="selectReportFieldContainer">
        <MuiGrid container spacing={isMobile ? 2 : 4}>
          {reportList?.map(
            ({
              id,
              reportName,
              reportURL,
              reportImagePath,
              reportImageAltText,
            }: any) => (
              <MuiGrid size={gridSize} key={id}>
                <CardForExternalLink
                  reportUrl={reportURL}
                  reportName={reportName}
                  reportImageUrl={reportImagePath}
                  reportImageAltText={reportImageAltText}
                  popupModalText={openInNewPageConfirmationLabel}
                  secondaryBtnText={stayHere}
                  primaryBtnText={commonLabels.proceed}
                />
              </MuiGrid>
            ),
          )}
        </MuiGrid>
      </MuiBox>
    </MuiBox>
  );
};
